"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstalledInfoResponseT = exports.InstalledInfoResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class InstalledInfoResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsInstalledInfoResponse(bb, obj) {
        return (obj || new InstalledInfoResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsInstalledInfoResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new InstalledInfoResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    isUdevInstalled() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    isWayland() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startInstalledInfoResponse(builder) {
        builder.startObject(2);
    }
    static addIsUdevInstalled(builder, isUdevInstalled) {
        builder.addFieldInt8(0, +isUdevInstalled, +false);
    }
    static addIsWayland(builder, isWayland) {
        builder.addFieldInt8(1, +isWayland, +false);
    }
    static endInstalledInfoResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createInstalledInfoResponse(builder, isUdevInstalled, isWayland) {
        InstalledInfoResponse.startInstalledInfoResponse(builder);
        InstalledInfoResponse.addIsUdevInstalled(builder, isUdevInstalled);
        InstalledInfoResponse.addIsWayland(builder, isWayland);
        return InstalledInfoResponse.endInstalledInfoResponse(builder);
    }
    unpack() {
        return new InstalledInfoResponseT(this.isUdevInstalled(), this.isWayland());
    }
    unpackTo(_o) {
        _o.isUdevInstalled = this.isUdevInstalled();
        _o.isWayland = this.isWayland();
    }
}
exports.InstalledInfoResponse = InstalledInfoResponse;
class InstalledInfoResponseT {
    constructor(isUdevInstalled = false, isWayland = false) {
        this.isUdevInstalled = isUdevInstalled;
        this.isWayland = isWayland;
    }
    pack(builder) {
        return InstalledInfoResponse.createInstalledInfoResponse(builder, this.isUdevInstalled, this.isWayland);
    }
}
exports.InstalledInfoResponseT = InstalledInfoResponseT;
